import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { GlobeIcon, FileTextIcon, ClipboardCheckIcon, UsersIcon, TruckIcon, TrendingUpIcon, ArrowRightIcon } from 'lucide-react';
export function Services() {
  const services = [{
    icon: GlobeIcon,
    title: 'Global Product Sourcing & Supplier Identification',
    description: 'We identify and vet manufacturers, exporters, and distributors capable of meeting large-volume procurement demands across all major sectors.'
  }, {
    icon: FileTextIcon,
    title: 'Procurement Coordination & Tender Support',
    description: 'End-to-end tender coordination including documentation preparation, specification review, and submission management for institutional procurement programmes.'
  }, {
    icon: ClipboardCheckIcon,
    title: 'Supplier Price & Specification Evaluation',
    description: 'Technical and commercial evaluation of supplier proposals against tender requirements, ensuring compliance, quality standards, and competitive pricing.'
  }, {
    icon: UsersIcon,
    title: 'Contract Allocation Assistance & Project Liaison',
    description: 'We facilitate communication between suppliers and procurement entities, coordinate contract negotiations, and provide ongoing project liaison services.'
  }, {
    icon: TruckIcon,
    title: 'Logistics Coordination & International Trade Support',
    description: 'Export documentation, freight coordination, customs clearance, and in-country delivery management for cross-border procurement projects.'
  }, {
    icon: TrendingUpIcon,
    title: 'Market Research & Procurement Advisory',
    description: 'Strategic advisory on African procurement markets, regulatory compliance, trade finance options, and market entry strategies for international suppliers.'
  }];
  return <section id="services" className="py-24 px-6 bg-navy-light" data-id="element-264">
      <div className="max-w-7xl mx-auto" data-id="element-265">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-266">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-267">
            <div className="w-12 h-px bg-gold" data-id="element-268"></div>
            <span className="text-gold text-xs font-semibold tracking-widest uppercase" data-id="element-269">
              Our Services
            </span>
            <div className="w-12 h-px bg-gold" data-id="element-270"></div>
          </div>
          <h2 className="text-4xl lg:text-5xl font-semibold text-white mb-4" data-id="element-271">
            Comprehensive Procurement Solutions
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto" data-id="element-272">
            From supplier identification to final delivery, we manage every
            aspect of institutional procurement
          </p>
        </motion.div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-273">
          {services.map((service, i) => <motion.div key={service.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-navy-dark border border-slate-800 hover:border-gold/50 p-8 rounded-lg transition-all group" data-id="element-274">
              <div className="w-12 h-12 bg-gold/10 border border-gold/30 rounded-lg flex items-center justify-center mb-6 group-hover:bg-gold/20 transition-colors" data-id="element-275">
                <service.icon size={24} className="text-gold" data-id="element-276" />
              </div>
              <h3 className="text-xl font-semibold text-white mb-3" data-id="element-277">
                {service.title}
              </h3>
              <p className="text-slate-400 leading-relaxed mb-4" data-id="element-278">
                {service.description}
              </p>
              <Link to="/services" className="text-gold text-sm font-medium flex items-center gap-2 hover:gap-3 transition-all" data-id="element-279">
                Learn more
                <ArrowRightIcon size={14} data-id="element-280" />
              </Link>
            </motion.div>)}
        </div>
      </div>
    </section>;
}